module.exports = __webpack_public_path__ + "img/error.b981d2c4.png";